import { cn } from '@lair-finance/util'
import { AssetItem } from '@/domains/header/components/Header/HeaderActions/WalletButton/WalletAsset/AssetItem.tsx'
import { TokenAddresses } from '@/shared/config/token.ts'
import { useTokenBalance } from '@/shared/lib/wagmi/hooks/useTokenBalance.ts'
import { ActiveChain } from '@/domains/chain'
import { formatAssetAmount } from '@/domains/header/components/Header/HeaderActions/WalletButton/WalletAsset/lib/formatAssetAmount.ts'

export function WalletAssetListBera({ className }: { className?: string }) {
  const chainId = ActiveChain.BERA.id
  const { balance: balanceBERA = '0' } = useTokenBalance({ chainId, watch: true })
  const { balance: balanceWBERA = '0' } = useTokenBalance({ chainId, tokenAddress: TokenAddresses[chainId].WBERA, watch: true })
  const { balance: balanceIBGT = '0' } = useTokenBalance({ chainId, tokenAddress: TokenAddresses[chainId].iBGT, watch: true })
  const { balance: balanceLAIR = '0' } = useTokenBalance({
    chainId,
    tokenAddress: TokenAddresses[chainId].LAIR,
    watch: true,
  })
  const { balance: balanceLrBGT = '0' } = useTokenBalance({
    chainId,
    tokenAddress: TokenAddresses[chainId].LrBGT,
    watch: true,
  })

  return (
    <div className={cn('flex flex-col gap-y-1', className)}>
      <AssetItem ticker={'LAIR'} amount={formatAssetAmount(balanceLAIR)} />
      <AssetItem ticker={'BERA'} amount={formatAssetAmount(balanceBERA)} />
      <AssetItem ticker={'WBERA'} amount={formatAssetAmount(balanceWBERA)} />
      <AssetItem ticker={'LrBGT'} amount={formatAssetAmount(balanceLrBGT)} />
      <AssetItem ticker={'iBGT'} amount={formatAssetAmount(balanceIBGT)} />
    </div>
  )
}
